import { gql } from '@apollo/client';

export const MessageThreadFields = gql`
  fragment MessageThreadFields on OdProtosHomeworkData_MessageThread {
    id
    status
    notes {
      id
      body
      createdAt
      user {
        fullName
      }
    }
  }
`;
